import { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { InfoContext } from '../components/context';

export default function Landing() {

    const { name, data, mailData, parterList } = useContext(InfoContext);

    useEffect(() => {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    }, [])

    const isMoreThan6MonthsOld = (dateString) => {
        if (!dateString) return false;
        const closeDate = new Date(dateString);
        const now = new Date();
        const monthsDiff = (now.getFullYear() - closeDate.getFullYear()) * 12 + (now.getMonth() - closeDate.getMonth());
        return monthsDiff > 6;
    }

    return (
        <>
            {!name && <div className="loading" aria-label="Vänligen vänta."></div>}
            <div>
                {name && <h3 className="medium-header">Hei {name},</h3>}
            </div>

            {data && mailData && <>
                <p>Klikkaa lukeaksesi viestin ja ladataksesi dokumentin</p>
                <div className="table" role="table" aria-label="Sendt post.">
                    <div className="table__row table__row__header" role="row">
                        <div className="table__cell title" role="columnheader">Päivämäärä</div>
                        <div className="table__cell title" role="columnheader">Tapaus</div>
                        <div className="table__cell title" role="columnheader">Aihe</div>
                        <div className="table__cell title" role="columnheader">Status</div>
                        <div className="table__cell title" role="columnheader">Liitteet</div>
                        <div className="table__cell title" role="columnheader" aria-hidden="true">Avaa</div>
                    </div>
                    {mailData && mailData.map((maildata, index) => {
                        return (
                            <Link className={`table__row ${!maildata.dateArchive && maildata?.docType?.toLowerCase() === "webportal" ? "bold" : ""}`} key={index} to={`/message/${maildata.id}`} aria-label="Klikkaa lukeaksesi dokumentin.">
                                <div className="table__cell" role="cell">{maildata.dateReceived.split("T")[0]}</div>
                                <div className="table__cell" role="cell">{maildata.claimid}</div>
                                <div className="table__cell" role="cell">{maildata.mailsubject}</div>
                                <div className={`table__cell ${maildata.docType === "webopplastning" ? "color-red" : "color-green"}`} role="cell">{maildata.docType === "webopplastning" ? "Lähetetty" : "Vastaanotettu"}</div>
                                <div className="table__cell" role="cell">{maildata.countAttachment}</div>
                                <div className="table__cell" role="cell" aria-hidden="true"><span className="action-button action-button__show"></span></div>
                            </Link>
                        )
                    })}
                </div>
            </>
            }
            <br /><br />
            {parterList && <>
                <p >Napsauta ladataksesi asiakirjoja tai lähettääksesi viestejä</p>
                <div className="table" role="table" aria-label="Asiakirjaluettelo">
                    <div className="table__row table__row__header" role="row">
                        <div className="table__cell title" role="columnheader">Tapausnumero</div>
                        <div className="table__cell title" role="columnheader">Nimi</div>
                        <div className="table__cell title" role="columnheader">Sähköpostiosoite</div>
                        <div className="table__cell title" role="columnheader" aria-hidden="true">Vastaa</div>
                    </div>
                    {parterList && parterList.filter(parterClaim => parterClaim.closeDate === null || !isMoreThan6MonthsOld(parterClaim.closeDate)).map((item, index) => {
                        return (
                            <Link className="table__row" role="row" key={index} to={`/upload/${item.claimNumber}`} aria-label="Klikkaa ladataksesi asiakirjan tai lähettääksesi viestin">
                                <div className="table__cell" role="cell">{item.claimNumber}</div>
                                <div className="table__cell" role="cell">{item.navn}</div>
                                <div className="table__cell" role="cell">{item.epost}</div>
                                <div className="table__cell" role="cell" aria-hidden="true"><span className="action-button action-button__reply"></span></div>
                            </Link>
                        )
                    })}

                </div>
            </>
            }
        </>
    )
}
